import React, { useState, useContext, createContext } from 'react';

const ModalContext = createContext(undefined);

export function ModalProvider({ children }) {
  const [deleteInvoice, setDeleteInvoice] = useState(true);
  return (
    <ModalContext.Provider value={{ deleteInvoice, setDeleteInvoice }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (!context) {
    const error = 'useModal must be used within a ModalProvider';
    throw new Error(error);
  }
  return context;
}
